module.exports = __webpack_public_path__ + "static/media/icon_internet-broken.5ea5739e.svg";